/** 브라우저 메모리·메인 스레드 보호용 업로드 상한 */

/** 동시 multipart 요청 수 (파일 1개씩 전송) */
export const MAX_CONCURRENT_UPLOADS = 1;

/** progress commit 최소 간격 (ms) */
export const PROGRESS_COMMIT_MIN_INTERVAL_MS = 400;

/** progress % 변화가 이 값 이상일 때만 Vuex 갱신 */
export const PROGRESS_COMMIT_MIN_STEP = 5;

/**
 * 이 크기 이하 ZIP만 JSZip.loadAsync 로 폴더·확장자 검증 (RAM에 전체 로드).
 * 초과분은 브라우저 검증 없이 서버 업로드만 진행 (OOM 방지).
 */
export const ZIP_BROWSER_VALIDATE_MAX_BYTES = 100 * 1024 * 1024;

/** 클라이언트에서 허용하는 ZIP 단일 파일 최대 크기 (5GB) */
export const ZIP_UPLOAD_MAX_BYTES = 5 * 1024 * 1024 * 1024;
